import { Object3D, PerspectiveCamera, Vector3 } from 'three';
import { useSPosStore } from '../stores/use-spos-store';

export default class SPosController {
  objs: Object3D[];
  constructor(objs: Object3D[]) {
    this.objs = objs;
  }
  update(camera: PerspectiveCamera) {
    const setScreenPos = useSPosStore.getState().setScreenPos;
    this.objs.forEach(tag => {
      const spos = tag.position.clone().project(camera);
      setScreenPos(tag.name, new Vector3(spos.x, spos.y, spos.z));
    });
  }
}
